import { matchPath, useLocation } from "react-router-dom";

import { ModalRoute } from "../Navigation/ModalRoute";
import { ModalTransitionSwitch } from "../Navigation/ModalTransitionSwitch";
import { CommonModalRoutes } from "./CommonModalRoutes";
import { SHIFT_DISCOVERY_TRAVEL_FOR_MORE_SHIFTS_PATH } from "./paths";
import { ShiftDiscoveryTravelForMoreShiftsModal } from "./TravelForMoreShifts/Modal";

interface TravelForMoreShiftsModalRoutesProps {
  baseNavigationPath: string;
}

export function TravelForMoreShiftsModalRoutes(props: TravelForMoreShiftsModalRoutesProps) {
  const { baseNavigationPath } = props;
  const location = useLocation();

  const travelForMoreShiftsPath = `${baseNavigationPath}/${SHIFT_DISCOVERY_TRAVEL_FOR_MORE_SHIFTS_PATH}`;

  // Generate modal key to prevent unmounting when nested modal is opened
  const modalKey = matchPath(location.pathname, {
    path: travelForMoreShiftsPath,
  })
    ? SHIFT_DISCOVERY_TRAVEL_FOR_MORE_SHIFTS_PATH
    : undefined;

  return (
    <>
      <ModalTransitionSwitch modalKey={modalKey}>
        <ModalRoute
          allowNestedPaths
          closeModalPath={baseNavigationPath}
          path={travelForMoreShiftsPath}
          render={({ modalState }) => {
            return <ShiftDiscoveryTravelForMoreShiftsModal modalState={modalState} />;
          }}
        />
      </ModalTransitionSwitch>
      <CommonModalRoutes baseNavigationPath={travelForMoreShiftsPath} />
    </>
  );
}
